import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Elevation, InputGroup } from '@blueprintjs/core';
import { useNavigate } from 'react-router-dom';
import { setAuthToken } from '../auth';
import './Login.css';

export default function Login({ onLoginSuccess }) {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [error, setError] = React.useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const response = await fetch('/api/auth/login', {
        method: 'post',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error('Invalid username or password');
      }

      const body = await response.json();
      setAuthToken(body.token);
      onLoginSuccess(body.user);
      navigate('/', { replace: true });
    } catch (submitError) {
      setError(submitError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login">
      <Card className="login__card" elevation={Elevation.TWO}>
        <h2>Torga Login</h2>
        <form action="/api/auth/login" method="post" onSubmit={handleSubmit}>
          <label className="login__label" htmlFor="login-username">
            Username
          </label>
          <InputGroup
            autoComplete="username"
            id="login-username"
            large
            name="username"
            onChange={(event) => setUsername(event.target.value)}
            placeholder="Username"
            required
            spellCheck={false}
            type="text"
            value={username}
          />
          <label className="login__label" htmlFor="login-password">
            Password
          </label>
          <InputGroup
            autoComplete="current-password"
            id="login-password"
            large
            name="password"
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Password"
            required
            type="password"
            value={password}
          />
          {error && <div className="login__error">{error}</div>}
          <Button fill intent="primary" loading={isSubmitting} type="submit">
            Sign in
          </Button>
        </form>
      </Card>
    </div>
  );
}

Login.propTypes = {
  onLoginSuccess: PropTypes.func.isRequired,
};
